'use client'
import Button from "@/components/inputs/button";
import InputWithValidation from "@/components/inputs/inputWithValidation";
import {useDispatch, useSelector} from "react-redux";
import {SET_ACTIVE_SIGNATURE, SET_PAYMENT_DATA, SET_PAYMENT_ID_PEDIDO} from "@/store/slices/paymentSlice";
import ContratoAssinatura from "@/components/texts/contratoAssinatura";
import { useEffect, useRef, useState } from "react";
import { isDigitoBradesco, isDocument } from "@/utils/validation";
import Nullable from "@/types/utils/Nullable";
import Events from "@/utils/Events";
import { GET_OFFER, GET_OFFER_TYPE } from "@/store/slices/offerSlice";
import { number } from "yup";
import { GET_USER } from "@/store/slices/userSlice";
import { SET_LEAD_CELULAR, SET_LEAD_ORIGEM_VENDA, SET_LEAD_TENTATIVA_TEF } from "@/store/slices/leadSlice";
import { useCookies } from "react-cookie";
import Apm from "@/utils/Apm";
import { PaymentTransform } from "@/utils/transform/payment";
import { GET_ALL_STATE, GET_USER_STEP, SET_LOADING, SET_MODAL, SET_RECAPTCHA, SET_USER_STEP } from "@/store/slices/appSlice";
import { isProduction } from "@/utils/environment";
import { blocked } from "@/utils/EmailBlockedList";
import { createPedido } from "@/api/assine";
import Lead from "@/utils/Lead";
import { SendDataSubscribe } from "@/utils/SendDataSubscribe";
import ReCAPTCHA from "react-google-recaptcha";
import { Col, Row } from "@/features/Endereco";
import useRecaptcha from "@/hooks/useRecaptcha";

export default function DebitoEmConta() {
    const oferta = useSelector(GET_OFFER)
    const states = useSelector(GET_ALL_STATE)
    const offer_type = useSelector(GET_OFFER_TYPE)
    const USER = useSelector(GET_USER) 
    const dispatch = useDispatch();
    const userStep = useSelector(GET_USER_STEP)

    const [documento, setDocumento] = useState('')
    const [agencia, setAgencia] = useState('')
    const [agencia_digito, setAgenciaDigito] = useState('')
    const [conta, setConta] = useState('')
    const [digito, setDigito] = useState('')
    const [documentoErrorMessage, setDocumentoErrorMessage] = useState<Nullable<string>>(null)
    const [agenciaErrorMessage, setAgenciaErrorMessage] = useState<Nullable<string>>(null)
    const [agenciaDigitoErrorMessage, setAgenciaDigitoErrorMessage] = useState<Nullable<string>>(null)
    const [contaErrorMessage, setContaErrorMessage] = useState<Nullable<string>>(null)
    const [digitoErrorMessage, setDigitoErrorMessage] = useState<Nullable<string>>(null)
    const [all_states, setAllStates] = useState(states)
    const [cookies, setCookie] = useCookies(['OESP_INFO'])
    const [btnDisabled, setBtn] = useState(false);
    const recaptcha = useRecaptcha()

    let value_offer = oferta.has_partner == true ? 0 : oferta.valor?.valor || oferta.valor?.original;
    const ecommerce = {
        item_id: oferta.cd_oferta,
        item_name: oferta.name,
        price: oferta.valor?.original || oferta.valor?.valor
    }

    const events = new Events();




    useEffect(() => {
        setAllStates(states) 
    }, [states]);


    async function saveToState(event: any) {
        event.preventDefault();
        let recaptchaObj: { token: string, action: string } | undefined = undefined;
        try {
            if (btnDisabled) {
                return;
            }
            setBtn(true);
            let recaptchaToken: string | undefined;
            try {
                recaptcha.reset();
                recaptchaToken = await recaptcha.validate('CHECKOUT');
                recaptchaObj = { token: recaptchaToken, action: 'CHECKOUT' };
                dispatch(SET_RECAPTCHA(recaptchaToken));
            } catch (error) {
                if (error instanceof Error && error.message.includes('DUPE')) {
                    dispatch(SET_MODAL({
                        show: true,
                        type: 'generic-error',
                        message: 'Sua tentativa expirou. Por favor, recarregue a página e tente novamente.'
                    }));
                    Apm.captureError('reCAPTCHA DUPE: Token reutilizado ou expirado');
                } else {
                    Apm.captureError(`reCAPTCHA Error: ${error}`);
                }
                dispatch(SET_LOADING(false));
                setBtn(false);
                recaptchaObj = undefined;
                return;
            }
        } catch (err) {
            dispatch(SET_LOADING(false));
            setBtn(false);
            recaptchaObj = undefined;
        }

        let formIsValid: boolean = true

        if(!isDocument(documento)){
            setDocumentoErrorMessage('Documento Inválido')
            events.trigger("pagamento_debito_erro_documento", { offer_type })
            formIsValid = false
        }else{
            setDocumentoErrorMessage('')
        }

        if(agencia.length < 3){
            setAgenciaErrorMessage('Agência é obrigatório')
            events.trigger("pagamento_debito_erro_agencia", { offer_type })
            formIsValid = false
        }else{
            setAgenciaErrorMessage('')
        }

        if(!isDigitoBradesco(agencia, agencia_digito, 'agencia')){
            setAgenciaDigitoErrorMessage('Digito é obrigatório')
            events.trigger("pagamento_debito_erro_dig_agencia", { offer_type })
            formIsValid = false
        }else{
            setAgenciaDigitoErrorMessage('')
        }

        if(conta.length < 5){
            setContaErrorMessage('Conta é obrigatório')
            events.trigger("pagamento_debito_erro_conta", { offer_type })
            formIsValid = false
        }else{
            setContaErrorMessage('')
        }

        if(!isDigitoBradesco(conta, digito, 'conta')){
            setDigitoErrorMessage('Digito inválido')
            events.trigger("pagamento_debito_erro_dig_conta", { offer_type })
            formIsValid = false
        }else{
            setDigitoErrorMessage('')
        }

        if(!formIsValid) {
            dispatch(SET_LOADING(false))
            setBtn(false)
            return
        }

        let telefone = null;
        try {
            let dispatched = false;
            dispatch(SET_PAYMENT_DATA({
                documento,
                agencia: Number(agencia), 
                agencia_digito: Number(agencia_digito),
                numero: Number(conta),
                digito: Number(digito),
                banco: 'bradesco',
                titular: USER.nome,
                dia: new Date().getDate(),
            }))

            if(typeof USER !== 'undefined' && typeof USER.telefone !== 'undefined') {
                dispatched = true;
                telefone = USER.telefone
                dispatch(SET_LEAD_CELULAR(USER.telefone))
            }
            if(!dispatched){
                const oesp_info = JSON.parse(cookies?.OESP_INFO);
                if(oesp_info && oesp_info.telefone) {
                    telefone = oesp_info.telefone
                    dispatch(SET_LEAD_CELULAR(oesp_info.telefone))
                }
            }
        } catch (error) {
            Apm.captureError(`DebitoConta() -> saveToState() FALHA AO CAPTURAR O TELEFONE DO USUÁRIO: ${error}`)
        }

        let data: any = {
            documento,
            agencia: Number(agencia), 
            agencia_digito: Number(agencia_digito),
            numero: Number(conta),
            digito: Number(digito),
            banco: 'bradesco',
            titular: USER.nome,
            dia: new Date().getDate(),
        }

        const objectToSend = new PaymentTransform(all_states, 'dc', new URL(window.location.toString()), data)
        dispatch(SET_LOADING(true))
        const objSend:any = objectToSend.process();
        if(objSend && typeof objSend.responsavel === 'object') {
            objSend.responsavel.celular = telefone
            objSend.responsavel.nome = USER.nome
            objSend.responsavel.sobrenome = USER.sobre_nome
        }

        events.trigger('add_payment_info', {
            event: 'add_payment_info',
            value: value_offer,
            ecommerce: ecommerce
        });
        objSend.recaptcha = recaptchaObj

        if(await blocked(objSend.responsavel.email)){
            dispatch(SET_MODAL({show: true, type: 'pagamento-duplicado'}))
            dispatch(SET_LOADING(false))
            setBtn(false)
            return
        }

        createPedido(objSend, true).then( async (res) => {
            if(typeof res === 'number'){
                Apm.captureError('ERRO NO DEBITCONTA A RESPOSTA ERA DO TIPO NUMBER')
                return
            }

            if(typeof res === 'string'){
                Apm.captureError('ERRO NO DEBITOCONTA A RESPOSTA ERA DO TIPO STRING')
                return
            }

            if ((res as any)?.activate_signature === true && res?.id_pedido) {
                document.cookie = `venda_suspeita=true;path=/;domain=.estadao.com.br;max-age=90000`;
                document.cookie = `id_pedido=${res.id_pedido};path=/;domain=.estadao.com.br;max-age=90000`;
            }

            Apm.addLabels({
                idPedido: res.id_pedido,
                id_transacao: res.id_transacao
            });

            Events.sendHotjarEvent("id_pedido_"+res.id_pedido);

            events.trigger('add_payment_info', {
                event: 'add_payment_info',
                value: value_offer,
                ecommerce: ecommerce
            });

            if (res.id_pedido) {
                dispatch(SET_PAYMENT_DATA(data))
                dispatch(SET_PAYMENT_ID_PEDIDO(res.id_pedido))
                dispatch(SET_LEAD_ORIGEM_VENDA(res.id_pedido))
                dispatch(SET_LEAD_TENTATIVA_TEF('S'))
                dispatch(SET_ACTIVE_SIGNATURE(res.activate_signature))
                Lead.save(states?.lead?.value, dispatch);
                dispatch(SET_USER_STEP(userStep + 1))
                await SendDataSubscribe({
                    orderid: res.id_pedido,
                    pageview: window.location.href,
                    timestamp: new Date().getTime().toString(),
                    useragent: navigator.userAgent,
                    userid: cookies.OESP_INFO.id,
                    gtm: typeof (window as any).google_tag_manager == 'undefined' ? "não" : "sim"
                })
            }
        }).catch((error) => {
            dispatch(SET_LOADING(false));
            setBtn(false);
            recaptchaObj = undefined;
            try {
                Apm.captureError(error);
                dispatch(SET_LEAD_TENTATIVA_TEF('S'))
                Lead.save(states.lead.value, dispatch);

                if (error && error.hasOwnProperty('response') && error.response.hasOwnProperty('status') && error.response.status === 409) {
                    dispatch(SET_MODAL({ type: "pagamento-duplicado", show: true }));
                } else if (error && error.hasOwnProperty('response') && error.response.hasOwnProperty('status') && (error.response.status === 402 || error.response.status === 401)) {
                    dispatch(SET_MODAL({ type: "falha-pagamento", show: true }));
                } else if (error && error.response && error.response.status === 201) {
                    dispatch(SET_USER_STEP(userStep + 1));
                }else{
                    dispatch(SET_MODAL({ type: "generic-error", show: true }))
                }
            } catch (e) {
                dispatch(SET_LOADING(false));
                setBtn(false);
            }
        }).finally(() => {
            dispatch(SET_LOADING(false));
            setBtn(false);
        });
    }
    return <form onSubmit={saveToState}>
        <InputWithValidation 
            id={"documento"}
            name={'documento'}
            type={'text'}
            placeholder={'CPF ou CNPJ'}
            errorMessage={documentoErrorMessage}
            onChange={setDocumento}
            OnClick={()=> {
                events.trigger("pagamento_debito_documento", { offer_type }),
                setDocumentoErrorMessage(null)
            }}
            value={documento}
        />
        <Row>
            <Col width="70%">
                <InputWithValidation
                    id={"agencia"}
                    maxLenght={4}
                    name={'agencia'}
                    type={'text'}
                    placeholder={'Agência'}
                    errorMessage={agenciaErrorMessage}
                    onChange={setAgencia}
                    OnClick={()=> {
                        events.trigger("pagamento_debito_agencia", { offer_type }),
                        setAgenciaErrorMessage(null)
                    }}
                    value={agencia}
                />
            </Col>
            <Col width="30%">
                <InputWithValidation
                    id={"agencia_digito"}
                    name={'agencia_digito'}
                    type={'text'}
                    maxLenght={1}
                    placeholder={'Dig.'}
                    errorMessage={agenciaDigitoErrorMessage}
                    onChange={setAgenciaDigito}
                    OnClick={()=> {
                        events.trigger("pagamento_debito_dig_agencia", { offer_type }),
                        setAgenciaDigitoErrorMessage(null)
                    }}
                    value={agencia_digito}
                />
            </Col>
        </Row>
        <Row>
            <Col width="70%">
                <InputWithValidation
                    id={"conta"}
                    name={'conta'}
                    type={'text'}
                    maxLenght={6}
                    placeholder={'Conta'}
                    errorMessage={contaErrorMessage}
                    onChange={setConta}
                    OnClick={()=> {
                        events.trigger("pagamento_debito_conta", { offer_type }),
                        setContaErrorMessage(null)
                    }}
                    value={conta}
                />
            </Col>
            <Col width="30%">
                <InputWithValidation
                    id={"digito"}
                    name={'digito'}
                    type={'text'}
                    placeholder={'Dig.'}
                    maxLenght={1}
                    errorMessage={digitoErrorMessage}
                    onChange={setDigito}
                    OnClick={()=> {
                        events.trigger("pagamento_debito_dig_conta", { offer_type }),
                        setDigitoErrorMessage(null)
                    }}
                    value={digito}
                />
            </Col>
        </Row>
       
        <Button id="continuar_step_3" data-transaction-name="pagamento_debito_concluir" type={'submit'} disabled={isProduction() && btnDisabled} onClick={()=>{events.trigger("pagamento_cartao_concluir", { offer_type })}}>Concluir Pagamento</Button>

        <ContratoAssinatura paymentMethod="debito"/>
    </form>
}